import { FC } from 'react';
import { clsx } from 'clsx';

import { ISkeletonDateHeaderProps } from '../models/ISkeletonDateHeaderProps';

import styles from './styles.module.scss';

export const SkeletonDateHeader: FC<ISkeletonDateHeaderProps> = ({
  isScrolledDown,
}) => {
  const columns = [
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
  ];

  return (
    <div className={styles['skeleton-date-header']}>
      {columns.map((cardsCount, columnIndex) => (
        <div
          key={columnIndex}
          className={styles['skeleton-date-header__column']}
        >
          {Array(cardsCount)
            .fill(null)
            .map((_, cardIndex) => (
              <div
                key={cardIndex}
                className={clsx(styles['skeleton-date-header__card'], {
                  [styles['skeleton-date-header__card_scrolled']]:
                    isScrolledDown,
                })}
              />
            ))}
        </div>
      ))}
    </div>
  );
};
